const initialState = {
    sidebarShow: 'responsive',
    cmsSelectedTab: 0
}

const changeState = (state = initialState, { type, ...rest }) => {
    switch (type) {
        case 'set':
            return { ...state, ...rest }
        case 'setTab':
            return { ...state, cmsSelectedTab: rest.payload }
        default:
            return state
    }
}

export default changeState